if (window) {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    window.pwaDeferredPrompt = event;
  });

  window.addEventListener('appinstalled', () => {
    window.pwaDeferredPrompt = null;
  });
}
